export default __webpack_public_path__ + "static/media/codecademy-logo.8b26084a.svg";